import { BillSessionFileResultBill } from './bill-session-file-result-bill';

export class BillSessionFile {
	public fileId: string;
	public fileName: string;
	public fileKey: string;
	public sessionId: string;
	public userId: string;
	public status: string;
	public errorMessage: string;
	public updatedAt: string | Date;
	public createdAt: string | Date;

	public result: {
		payloadVersion?: string;
		count: number;
		commodity?: string;
		unit?: string;
		statementDate?: string;
		issuer?: string;
		issuerName?: string;
		issuerCategory?: string;
		utilityName?: string;
		customerName?: string;
		error?: string;
		bills: BillSessionFileResultBill[];
	};

	// internal use
	public s3Path?: string;
	public errorCount?: number;

	constructor(billSessionFile?: BillSessionFile) {
		Object.assign(this, billSessionFile);

		this.errorCount = this.errorMessage ? this.errorMessage.split(';').length : this.result?.bills?.some(b => b.error) ? 1 : 0;
		this.errorMessage = (this.errorMessage || this.result?.bills?.map(b => b.error).join('; ')) ?? '';
		this.s3Path = 's3://bill-reader-ai/' + this.fileKey;
		this.updatedAt = new Date(this.updatedAt);
		this.createdAt = new Date(this.createdAt);
	}
}
